// @flow
const PREFIX = 'hive/ui/sensor-logs/audio-player/';

export const AUDIO_DATA_RECEIVED = `${PREFIX}AUDIO_DATA_RECEIVED`;
export const CLEAR_DATA = `${PREFIX}CLEAR_DATA`;
export const GET_AUDIO_DATA = `${PREFIX}GET_AUDIO_DATA`;



// WEBPACK FOOTER //
// ./src/core/state/ui/sensor-logs/audio-player/constants.js